import React from 'react';
import ListView from './ListView';
import PropTypes from 'prop-types';
import ListFooter from './ListFooter';

const CmtList = ({footerProps, data, renderRow}) => {
  const filteredData = data.filter((item) => item.value !== undefined);

  return (
    <ListView
      // {...props}
      data={filteredData}
      renderRow={renderRow}
      ListFooterComponent={
        footerProps && (
          <ListFooter loading={footerProps.loading} footerText={footerProps.footerText} />
        )
      }
    />
  );
};

export default CmtList;
CmtList.propTypes = {
  ListEmptyComponent: PropTypes.element,
  ListFooterComponent: PropTypes.element,
  data: PropTypes.array.isRequired,
  onEndReached: PropTypes.func,
  footerProps: PropTypes.object,
};
CmtList.defaultProps = {
  data: [],
};
